import styled from "styled-components"

const inspectorWidth = "350px"
const breadCrumbHeight = "30px"

export const ModelWrapper = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
`
export const InspectorWrapper = styled.div`
    height: 100%;
    width: ${inspectorWidth};
    position: absolute;
    top: 0;
    right: 0;
    overflow-y: scroll;
    background: ${(props) => props.theme.lifecycleInspectorBackgroundColor};
`
export const CanvasWrapper = styled.div`
    height: calc(100% - ${breadCrumbHeight});
    width: calc(100% - ${inspectorWidth});
    position: absolute;
    top: ${breadCrumbHeight};
    left: 0;
`
export const BreadCrumbWrapper = styled.div`
    height: ${breadCrumbHeight};
    width: calc(100% - ${inspectorWidth});
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    padding: 0 10px;
    background: ${(props) => props.theme.lifecycleBreadCrumbsBackgroundColor};
`
export const BreadCrumbItem = styled.div`
    display: flex;
    align-items: center;
`
export const BreadCrumbDelimiter = styled.div`
    display: flex;
    padding: 0 8px;

    &:before {
        padding: 0 2px;
        color: #6c757d;
        content: ">";
    }
`
export const InspectorEmptySpan = styled.span`
    color: ${(props) => props.theme.lifecycleInspectorEmptyColor};
`
